import {
  ProductSupplier,
  ServicesWrapper,
  ContractInformation,
  ScoreEntity,
  SellingPoint,
} from '../graphProduct';
import { Scalars, Maybe } from './graphSchemaScalars';

export type Tripleplay = {
  comparisonId: string;
  products: TripleplayProduct[];
};

type CommonTechnical = {
  accessCode?: string;
  senderId: string | undefined;
  sessionId: string | undefined;
  transactionReference: string;
};

export type OsTripleplay = {
  products: OsTripleplayProduct[];
  commonTechnical: Maybe<Array<CommonTechnical>>;
};

export type TripleplayProduct = {
  type: string;
  packageCosts: {
    discount: number;
    cbDiscount: number;
    monthlyCosts: {
      standardRate: number;
      priceList: {
        priceList: PriceListItem[];
      };
    };
    onceOffCosts: {
      closingCosts: number;
      connectionCosts: number;
      installations: {
        installation: Installation[];
      };
      postageCosts: number;
    };
    total: number;
    discountSource: string;
  };
  servicesWrapper: ServicesWrapper;
  specialOfferWrapper: { specialOffer: any };
  subscriptionId: string;
  orderFormId: string;
  supplier: ProductSupplier;
  contractInformation: ContractInformation;
  packages: ChannelPackage;
  channels?: string[];
  scoreEntity: ScoreEntity;
  subscriptionName: string;
  customerBenefits: {
    customerBenefit: {
      name: string;
      product: { id: string; type: string; remark: string };
      supplier: { id: string; name: string };
      advantages: {
        advantages: {
          descriptions: {
            description: { type: string; remark: string }[];
          };
        }[];
      };
    }[];
  };
  tags?: any;
};

export type OsTripleplayProduct = {
  name: string;
  affiliateUrl: string;
  productCode: string;
  sellingPoints: SellingPoint[] | null;
  companyNameDescription: string;
  refKey: string;
  totalInstallmentAmount: Scalars['Decimal'];
  paymentTermInMonths: Scalars['Int'];
  netPremiumInstallment: Scalars['Decimal'];
  grossPremiumInstallment: Scalars['Decimal'];
  customProperties: {
    supplierKrn: string;
    customAttributes: [
      {
        description: string;
        value: string;
      },
    ];
  };
  underwritingCompanySpecifics: [
    {
      refKey: string;
      underwritingResult: string;
    },
  ];
  supplier: ProductSupplier;
  productIncentives?: {
    productIncentiveDetailsKrn: string;
  }[];
};

export type PriceListItem = {
  amount: number;
  periodInMonth: number;
};

export type ApplicationDate = {
  __typename?: 'ApplicationDate';
  date: Scalars['DateTime'];
  timeStamp: Scalars['String'];
};

export type CalculationOutput = {
  __typename?: 'CalculationOutput';
  comparisonId: Scalars['String'];
  products: Array<ProductWrapper>;
  calculationDate: Scalars['DateTime'];
};

export type CallInformation = {
  __typename?: 'CallInformation';
  numberPorting: ProductNode;
  callerIdVisibility: ProductNode;
  rate: CallRate;
  bundles: ProductNode;
  voicemail: ProductNode;
};

export type CallRate = {
  __typename?: 'CallRate';
  startingRate: Scalars['Decimal'];
  rateWithinRegion: Scalars['Decimal'];
  rateOutsideRegion: Scalars['Decimal'];
  mobile: Scalars['Decimal'];
};

export type ChannelPackage = {
  __typename?: 'ChannelPackage';
  name: Scalars['String'];
  remarks?: Maybe<Scalars['String']>;
  costs: Costs;
};

export type ChannelWrapper = {
  __typename?: 'ChannelWrapper';
  channelPackages: Array<ChannelPackage>;
};

export type Channels = {
  __typename?: 'Channels';
  numberOfTvChannels: Scalars['Int'];
  numberOfHdChannels: Scalars['Int'];
  numberOfRadioChannels: Scalars['Int'];
  channelsPackages: ChannelWrapper;
};

export type Component = {
  __typename?: 'Component';
  position: Scalars['Int'];
  input: Scalars['Boolean'];
  type: Scalars['String'];
  name: Scalars['String'];
  label: Scalars['String'];
  value: Scalars['String'];
  values?: Maybe<Array<Value>>;
  hidden?: Maybe<Scalars['Boolean']>;
  validation?: Maybe<Validation>;
  conditional?: Maybe<Array<Conditional>>;
  props?: Maybe<Props>;
};

export type Conditional = {
  __typename?: 'Conditional';
  showField?: Maybe<Scalars['String']>;
  match?: Maybe<Scalars['Int']>;
};

export type Costs = {
  __typename?: 'Costs';
  monthlyCosts?: Maybe<Item>;
  onceOffCosts?: Maybe<Item>;
};

export type CustomerBenefit = {
  __typename?: 'CustomerBenefit';
  provider: Array<ProviderCustomerBenefit>;
  total: Scalars['Int'];
};

export type DataLimit = {
  __typename?: 'DataLimit';
  available: Scalars['String'];
  limiet: Scalars['String'];
  rate: Scalars['String'];
  remarks?: Maybe<Scalars['String']>;
};

export type Decoder = {
  __typename?: 'Decoder';
  name: Scalars['String'];
  rate: Scalars['Decimal'];
  remarks?: Maybe<Scalars['String']>;
};

export type DecoderWrapper = {
  __typename?: 'DecoderWrapper';
  decoders: Array<Decoder>;
};

export type EmailBoxes = {
  __typename?: 'EmailBoxes';
  numberOfEmailBoxes: Scalars['Int'];
  sizeOfEmailBox: Scalars['String'];
};

export type EmailData = {
  __typename?: 'EmailData';
  emailBoxes: EmailBoxes;
  numberOfAliasesPerBox: Scalars['String'];
  spamFilter?: Maybe<NetworkFilter>;
  virusFilter?: Maybe<NetworkFilter>;
  webmail?: Maybe<Webmail>;
};

export type Energy = {
  __typename?: 'Energy';
  product: Array<ProductCustomerBenefit>;
};

export type FixedIp = {
  __typename?: 'FixedIp';
  available: Scalars['Int'];
};

export type FormOutput = {
  __typename?: 'FormOutput';
  steps: Array<FormInputStep>;
};

export type Hdtv = {
  __typename?: 'HDTV';
  available: Scalars['Int'];
  remarks?: Maybe<Scalars['String']>;
};

export type Homepage = {
  __typename?: 'Homepage';
  available: Scalars['Int'];
  mode: Scalars['String'];
  sizeInMb: Scalars['Int'];
};

export type Installation = {
  __typename?: 'Installation';
  available: Scalars['Boolean'];
  name: Scalars['String'];
  rate: Scalars['Decimal'];
  remarks?: Maybe<Scalars['String']>;
};

export type Installations = {
  __typename?: 'Installations';
  installation: Array<Installation>;
};

export type InternetSpeed = {
  __typename?: 'InternetSpeed';
  downloadSpeedInBytes: Scalars['Int'];
  downloadSpeedInMb: Scalars['Int'];
  uploadSpeedInBytes: Scalars['Int'];
  uploadSpeedInMb: Scalars['Int'];
};

export type Item = {
  __typename?: 'Item';
  costSpecifics: Specifics;
};

export type MissedProgramsData = {
  __typename?: 'MissedProgramsData';
  available: Scalars['Int'];
  numberOfChannels: Scalars['String'];
  remarks?: Maybe<Scalars['String']>;
};

export type MissedStart = {
  __typename?: 'MissedStart';
  available: Scalars['Int'];
  channels: Scalars['Int'];
  remarks?: Maybe<Scalars['String']>;
};

export type Mobile = {
  __typename?: 'Mobile';
  product: Array<ProductCustomerBenefit>;
};

export type Modem = {
  __typename?: 'Modem';
  name: Scalars['String'];
};

export type ModemData = {
  __typename?: 'ModemData';
  modem: Array<Modem>;
};

export type Mutation = {
  __typename?: 'Mutation';
  orderTriplePlay: OrderOutput;
};

export type MutationOrderTriplePlayArgs = {
  orderInput: OrderInput;
};

export type NetworkFilter = {
  __typename?: 'NetworkFilter';
  available: Scalars['Int'];
  name: Scalars['String'];
};

export type NetworkInformation = {
  __typename?: 'NetworkInformation';
  internetSpeed: InternetSpeed;
  network: NetworkType;
  email: EmailData;
  modems: ModemData;
  dataLimit: DataLimit;
  homepage: Homepage;
  newsgroups: NewsGroup;
  fixedIp: FixedIp;
  ownServer: OwnServer;
};

export type NetworkType = {
  __typename?: 'NetworkType';
  signal: Scalars['String'];
  supplierName: Scalars['String'];
};

export type NewsGroup = {
  __typename?: 'NewsGroup';
  available: Scalars['Int'];
};

export type NumberTvs = {
  __typename?: 'NumberTvs';
  available: Scalars['Int'];
  remarks?: Maybe<Scalars['String']>;
};

export type OnceOffCosts = {
  __typename?: 'OnceOffCosts';
  postageCosts: Scalars['Decimal'];
  connectionCosts: Scalars['Decimal'];
  closingCosts: Scalars['Decimal'];
  installations: Installations;
};

export type Order = {
  __typename?: 'Order';
  id: Scalars['Int'];
  hash: Scalars['String'];
  answers: Scalars['Int'];
  remarks?: Maybe<Scalars['String']>;
};

export type OrderOutput = {
  __typename?: 'OrderOutput';
  order: Order;
  applicationDate: ApplicationDate;
};

export type OwnServer = {
  __typename?: 'OwnServer';
  available: Scalars['Int'];
};

export type PackagePrice = {
  __typename?: 'PackagePrice';
  standardRate: Scalars['Decimal'];
  priceList?: Maybe<PackagePriceWrapper>;
};

export type PackagePriceSpecifics = {
  __typename?: 'PackagePriceSpecifics';
  periodInMonth: Scalars['Int'];
  amount: Scalars['Decimal'];
};

export type PackagePriceWrapper = {
  __typename?: 'PackagePriceWrapper';
  priceList: Array<PackagePriceSpecifics>;
};

export type PauseLiveTv = {
  __typename?: 'PauseLiveTv';
  available: Scalars['Int'];
};

export type PriceData = {
  __typename?: 'PriceData';
  monthlyCosts: PackagePrice;
  onceOffCosts: OnceOffCosts;
  discount: Scalars['Decimal'];
  total: Scalars['Decimal'];
};

export type ProductCustomerBenefit = {
  __typename?: 'ProductCustomerBenefit';
  id: Scalars['Int'];
  text?: Maybe<Scalars['String']>;
};

export type ProductNode = {
  __typename?: 'ProductNode';
  available: Scalars['Int'];
  numberOfChannels?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
};

export type ProductWrapper = {
  __typename?: 'ProductWrapper';
  subscriptionId: Scalars['String'];
  supplierName: Scalars['String'];
  specialOfferWrapper: SpecialOfferWrapper;
  packageCosts: PriceData;
  servicesWrapper: Services;
};

export type Products = {
  __typename?: 'Products';
  mobile?: Maybe<Mobile>;
  energy?: Maybe<Energy>;
};

export type Props = {
  __typename?: 'Props';
  title: Scalars['String'];
  items: Array<Scalars['String']>;
  bottomText: Scalars['String'];
  variant: Scalars['String'];
};

export type Provider = {
  __typename?: 'Provider';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type ProviderCustomerBenefit = {
  __typename?: 'ProviderCustomerBenefit';
  name: Scalars['String'];
  product: Products;
  id: Scalars['Int'];
};

export type Query = {
  __typename?: 'Query';
  calculateTriplePlay: CalculationOutput;
  formsTriplePlay: FormOutput;
  providerList: Array<Provider>;
  customerBenefit: CustomerBenefit;
};

export type QueryCalculateTriplePlayArgs = {
  input: CalculationInput;
};

export type QueryFormsTriplePlayArgs = {
  subscriptionId: Scalars['Int'];
};

export type Recording = {
  __typename?: 'Recording';
  available: Scalars['Int'];
  technic: Scalars['String'];
  recordingTimeInHours: Scalars['Int'];
  numberOfChannels?: Maybe<Scalars['String']>;
  rate: Scalars['Decimal'];
  remarks?: Maybe<Scalars['String']>;
};

export type Services = {
  __typename?: 'Services';
  filterNetworkInformation: Scalars['Boolean'];
  filterTelevisionInfo: Scalars['Boolean'];
  filterCallInfo: Scalars['Boolean'];
  networkInformation?: Maybe<NetworkInformation>;
  televisionInfo?: Maybe<TelevisionInformation>;
  callInfo?: Maybe<CallInformation>;
};

export type ServicesFilterNetworkInformationArgs = {
  fd: FilterDataInput;
};

export type ServicesFilterTelevisionInfoArgs = {
  fd: FilterDataInput;
};

export type ServicesFilterCallInfoArgs = {
  fd: FilterDataInput;
};

export type SpecialOffer = {
  __typename?: 'SpecialOffer';
  version: Scalars['String'];
  text: Scalars['String'];
};

export type SpecialOfferWrapper = {
  __typename?: 'SpecialOfferWrapper';
  validUntilInUnixTime: Scalars['String'];
  validUntil: Scalars['DateTime'];
  specialOffer: Array<SpecialOffer>;
};

export type Specifics = {
  __typename?: 'Specifics';
  periodInMonth: Scalars['Int'];
  rate: Scalars['String'];
  remarks?: Maybe<Scalars['String']>;
};

export type FormInputStep = {
  __typename?: 'Step';
  position: Scalars['Int'];
  title: Scalars['String'];
  components?: Maybe<Array<Component>>;
};

export type TelevisionInformation = {
  __typename?: 'TelevisionInformation';
  channels: Channels;
  decoders: DecoderWrapper;
  hDTV: Hdtv;
  numberTvs: NumberTvs;
  missedPrograms: MissedProgramsData;
  recordPrograms: Recording;
  pauseLiveTv: PauseLiveTv;
  missedStart: MissedStart;
  videoOnDemand: ProductNode;
  guide: ProductNode;
};

export type Validation = {
  __typename?: 'Validation';
  required: Scalars['Boolean'];
};

export type Value = {
  __typename?: 'Value';
  field?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
  format?: Maybe<Scalars['String']>;
  information?: Maybe<Scalars['String']>;
};

export type Webmail = {
  __typename?: 'Webmail';
  available: Scalars['Int'];
  remarks?: Maybe<Scalars['String']>;
};

export type _SchemaDefinition = {
  __typename?: '_SchemaDefinition';
  name: Scalars['String'];
  document: Scalars['String'];
  extensionDocuments: Array<Scalars['String']>;
};

export type CalculationInput = {
  address?: Maybe<KiziAddressInput>;
  customerBenefit?: Maybe<Array<Scalars['Int']>>;
  filters?: Maybe<Array<InputFilterDataInput>>;
  comparisonId?: Maybe<Scalars['String']>;
  retention?: Maybe<Scalars['String']>;
};

export type FieldInput = {
  id: Scalars['Int'];
  value: Scalars['String'];
};

export type FilterDataInput = {
  isMove: Scalars['Boolean'];
  productTypes: Array<PackageTypeEnum>;
  minPrice?: Maybe<Scalars['Decimal']>;
  maxPrice?: Maybe<Scalars['Decimal']>;
  suppliers?: Maybe<Array<Scalars['String']>>;
  installation?: Maybe<Scalars['Boolean']>;
  maxDownloadSpeed?: Maybe<Scalars['Int']>;
  minDownloadSpeed?: Maybe<Scalars['Int']>;
  maxUploadSpeed?: Maybe<Scalars['Int']>;
  minUploadSpeed?: Maybe<Scalars['Int']>;
  signal?: Maybe<Array<Scalars['String']>>;
  specificTvChannel?: Maybe<Array<Scalars['String']>>;
  pauseLiveTv?: Maybe<Scalars['Int']>;
  missedStart?: Maybe<Scalars['Int']>;
  recordingTimeInHours?: Maybe<Scalars['Int']>;
  missedPrograms?: Maybe<Scalars['Int']>;
  recordPrograms?: Maybe<Scalars['Int']>;
  videoOnDemand?: Maybe<Scalars['Int']>;
  numberPorting?: Maybe<Scalars['Int']>;
};

export type InputFilterDataInput = {
  category: Scalars['String'];
  name: Scalars['String'];
  value: Scalars['String'];
};

export type KiziAddressInput = {
  houseNumber?: Maybe<Scalars['Int']>;
  houseNumberAddition?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
};

export type OrderInput = {
  fields: Array<FieldInput>;
  subscriptionId: Scalars['Int'];
  ipAddress: Scalars['String'];
};

export enum ApplyPolicy {
  BeforeResolver = 'BEFORE_RESOLVER',
  AfterResolver = 'AFTER_RESOLVER',
}

export enum PackageTypeEnum {
  Internet = 'INTERNET',
  Television = 'TELEVISION',
  Call = 'CALL',
}
